<template>
  <sidebar-item>
    <h2>{{ linksTitle }}</h2>
    <p>
      <span v-for="(link, index) in links" :key="link.id">
        <a class="show-sidebar-link" target="_blank" :href="link.href">{{ link.title }}</a>{{ index !== links.length - 1 ? ',' : ''}}
      </span>
    </p>
  </sidebar-item>
</template>
<script>
import SidebarItem from '../Common/Sidebar/SidebarItem'

export default {
  name: 'sidebar-links',
  props: {
    item: {
      type: Object,
      required: true
    },
    linkName: {
      type: String,
      default: null
    },
    show: {
      type: Object,
      default: null
    }
  },
  components: {
    SidebarItem
  },
  computed: {
    linksTitle() {
      return this.$gettext('Externí odkazy')
    },
    links() {
      const linkName = this.linkName || (this.item.show && this.item.show.name) || this.item.name
      return [
        { title: 'ČSFD', href: this.csfdLink || `https://www.csfd.cz/hledat/?q=${linkName || ''}` },
        { title: 'IMDb', href: this.imdbLink || `https://www.imdb.com/find?q=${linkName || ''}` },
        { title: 'Images', href: `https://www.google.cz/search?q=${linkName || ''} poster&tbm=isch` },
        { title: 'YouTube', href: `https://www.youtube.com/results?search_query=${linkName || ''} trailer` },
        { title: 'ČT', href: `http://www.ceskatelevize.cz/hledani/?q=${linkName || ''}` }
      ]
    },
    csfdLink() {
      if (this.show) {
        if (this.show.csfdId) {
          return 'https://www.csfd.cz/film/' + this.show.csfdId
        } else {
          return null
        }
      } else {
        if (this.item.csfdId) {
          return 'https://www.csfd.cz/film/' + this.item.csfdId
        } else {
          return null
        }
      }
    },
    imdbLink() {
      if (this.show) {
        if (this.show.imdbId) {
          return 'https://www.imdb.com/title/' + this.show.imdbId
        }
      } else {
        if (this.item.imdbId) {
          return 'https://www.imdb.com/title/' + this.item.imdbId
        } else {
          return null
        }
      }
    }
  }
}
</script>
